export const CeckConnection = () => {
  var ifConnected = window.navigator.onLine;
  return ifConnected ? true : false;
};
